import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Typography } from 'antd';
import { makeStyles } from '@material-ui/styles';
import textIcon from '../../asset/text.svg';
import richTextIcon from '../../asset/richtext.svg';
import mediaIcon from '../../asset/media.svg';
import dateIcon from '../../component/DatePicker/Date.svg';
import CButton from '../../component/Button';
import ArrowBack from '../../asset/arrow-back.svg';
import checkBoxIcon from '../../asset/checkbox.svg';
import './contentModelDetail.css';
import { CStandardInput } from '../../component/Input';
import { AutocompleteSelect } from '../../component/Select';
import Modal from '../../component/Modal/Modal';

const useStyles = makeStyles({
  garbage: {
    cursor: 'pointer',
    left: '8px',
    position: 'absolute',
    top: '0px'
  },
  keyWrapper: {
    '& p': {
      margin: '0px'
    },
    alignItems: 'center',
    display: 'flex'
  },
  removeButton: {
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    display: 'inline-block',
    margin: '0',
    padding: '0',
    width: '18px'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '12.75px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  }
});

const { Title, Text } = Typography;

const ChooseFieldType = ({ onClick }) => {
  const types = [
    {
      icon: textIcon,
      subtitle: 'Titles, names, paragraphs, list of names',
      title: 'Text'
    },
    {
      icon: richTextIcon,
      subtitle: 'Text formatting with references and media',
      title: 'Rich text'
    },
    {
      icon: mediaIcon,
      subtitle: 'Upload Images',
      title: 'Media'
    },
    {
      icon: mediaIcon,
      subtitle: 'Upload Files, PDF and KML',
      title: 'Files'
    },
    {
      icon: richTextIcon,
      subtitle: 'List of Items',
      title: 'List'
    },
    {
      icon: dateIcon,
      subtitle: 'Pick date',
      title: 'Date'
    },
    {
      icon: richTextIcon,
      subtitle: 'Create object',
      title: 'Complex list'
    },
    {
      icon: richTextIcon,
      subtitle: 'Connect Content Model & Content',
      title: 'Connect To Content'
    },
    {
      icon: richTextIcon,
      subtitle: 'Create Page Content',
      title: 'Page Content'
    },
    {
      icon: checkBoxIcon,
      subtitle: 'Add Checkbox to Content Model',
      title: 'checkbox'
    },
    {
      icon: richTextIcon,
      subtitle: 'create and select predetermined values',
      title: 'Select'
    }
  ];

  const onColClick = (index) => {
    return () => onClick(index);
  };

  return (
    <Row gutter={64} justify="flex-start">
      {types.map(({ icon, title, subtitle }, index) => {
        return (
          <Col
            key={index}
            align="center"
            height="100%"
            onClick={onColClick(index)}
            span={8}
            style={{ paddingBottom: '1rem' }}
          >
            <img
              alt=""
              height={48}
              src={icon}
              style={{
                background: '#F0F4FF',
                borderRadius: '8px',
                padding: '6px'
              }}
              width={48}
            />

            <Title
              level={4}
              style={{
                color: '#9BA0AD',
                fontSize: '14px',
                fontWeight: 500,
                marginTop: '20px'
              }}
            >
              {title}
            </Title>
            <Text style={{ color: '#9BA0AD', fontSize: '10px', fontWeight: 400 }}>{subtitle}</Text>
          </Col>
        );
      })}
    </Row>
  );
};

const FieldDetails = ({
  onNameChange,
  onApiIdChange,
  onHintChange,
  onCharacterLimitChange,
  selectedFieldType,
  onRichTextChange,
  onWidthChange,
  onHeightChange,
  onSizeLimitChange,
  onObjectKeyChange,
  objectKey,
  addObjectKey,
  objectData,
  onSelectElementChange,
  removeKey,
  remainingContentModelsToSelect,
  selectContentModel,
  selectedContentModelData,
  selectElement,
  addSelectData,
  removeSelectElement,
  selectData
}) => {
  const classes = useStyles();
  const [showObjectModal, setShowObjectModal] = useState(false);

  const objectKeys = Object.keys(objectData);
  const sortedContentModels = remainingContentModelsToSelect.sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  );

  switch (selectedFieldType) {
    case 'text':
      return (
        <div>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-name"
                id="standard-input-content-model-detail-text-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-id"
                id="standard-input-content-model-detail-text-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-hint"
                id="standard-input-content-model-detail-text-hint"
                label="Hint"
                onChange={onHintChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear={false}
                defaultValue={64}
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-limit"
                id="standard-input-content-model-detail-text-limit"
                label="Character Limit"
                onChange={onCharacterLimitChange}
                size="large"
                type="number"
                width="true"
              />
            </Col>
          </Row>
        </div>
      );

    case 'list':
      return (
        <div style={{ width: '100%' }}>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-name"
                id="standard-input-content-model-detail-text-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-id"
                id="standard-input-content-model-detail-text-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>
          </Row>
        </div>
      );

    case 'file':
      return (
        <div>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-file-name"
                id="standard-input-content-model-detail-file-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-file-id"
                id="standard-input-content-model-detail-file-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>

            <Col align="bottom" style={{ width: '100%' }}>
              <Row justify="space-between">
                <Col
                  span={11}
                  style={{
                    display: 'flex',
                    marginTop: '24px'
                  }}
                >
                  <CStandardInput
                    allowClear
                    disableUnderline
                    formclasses={{ root: classes.root }}
                    htmlFor="standard-input-content-model-detail-file-limit"
                    id="standard-input-content-model-detail-file-limit"
                    label="Aspect Ratio: Width"
                    onChange={onWidthChange}
                    size="large"
                    type="number"
                    width="true"
                  />
                </Col>
                <Col
                  span={11}
                  style={{
                    display: 'flex',
                    marginLeft: '5px',
                    marginTop: '24px'
                  }}
                >
                  <CStandardInput
                    allowClear
                    disableUnderline
                    formclasses={{ root: classes.root }}
                    htmlFor="standard-input-content-model-detail-file-limit"
                    id="standard-input-content-model-detail-file-limit"
                    label="Aspect Ratio: Height"
                    onChange={onHeightChange}
                    size="large"
                    type="number"
                    width="true"
                  />
                </Col>
              </Row>
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-file-limit"
                id="standard-input-content-model-detail-file-limit"
                label="Size Limit"
                onChange={onSizeLimitChange}
                size="large"
                type="number"
                width="true"
              />
            </Col>
          </Row>
        </div>
      );

    case 'files':
      return (
        <div>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-file-name"
                id="standard-input-content-model-detail-file-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-file-id"
                id="standard-input-content-model-detail-file-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>
          </Row>
        </div>
      );
    case 'date':
      return (
        <div style={{ width: '100%' }}>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-name"
                id="standard-input-content-model-detail-text-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-id"
                id="standard-input-content-model-detail-text-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>
          </Row>
        </div>
      );

    case 'complex list':
      return (
        <div style={{ width: '100%' }}>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-name"
                id="standard-input-content-model-detail-text-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-id"
                id="standard-input-content-model-detail-text-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>

            <Col
              span={24}
              style={{
                alignItems: 'flex-end',
                display: 'flex',
                marginTop: '24px'
              }}
            >
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-object-key"
                id="standard-input-content-model-detail-object-key"
                label="object key"
                onChange={onObjectKeyChange}
                size="large"
                value={objectKey}
                width="true"
              />
              <CButton onClick={addObjectKey} size="large" type="primary">
                Add
              </CButton>
              <CButton onClick={() => setShowObjectModal(true)} size="large" type="primary">
                View
              </CButton>
            </Col>

            {showObjectModal && (
              <Modal
                handleClose={() => setShowObjectModal(false)}
                isModalOpen={showObjectModal}
                styles={{
                  '& .MuiDialogContent-root': {
                    padding: '8px 24px 24px'
                  },
                  minHeight: '187px',
                  width: '460px'
                }}
                titleContent={<h2 className="modal-title">Keys</h2>}
              >
                {objectKeys.map((key, index) => {
                  return (
                    <div key={index} className={classes.keyWrapper}>
                      <button
                        className={classes.removeButton}
                        onClick={() => removeKey(key)}
                        type="button"
                      >
                        x
                      </button>
                      <p>{key}</p>
                    </div>
                  );
                })}
              </Modal>
            )}
          </Row>
        </div>
      );

    case 'Connect To Content':
      return (
        <div style={{ width: '100%' }}>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-name"
                id="standard-input-content-model-detail-text-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>
            <Col span={24}>
              <AutocompleteSelect
                getOptionLabel={(option) => option?.name}
                id="autocomplete-newFieldModal-selectContentModel"
                onSelect={selectContentModel}
                options={sortedContentModels}
                placeholderValue={selectedContentModelData?.name || 'Select Content Model'}
                styles={{ marginTop: '24px' }}
              />
            </Col>
          </Row>
        </div>
      );

    case 'Content Model':
      return (
        <div style={{ width: '100%' }}>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-name"
                id="standard-input-content-model-detail-text-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>
            <Col span={24}>
              <AutocompleteSelect
                getOptionLabel={(option) => option?.name}
                id="autocomplete-newFieldModal-selectContentModel"
                onSelect={selectContentModel}
                options={sortedContentModels}
                placeholderValue={selectedContentModelData?.name || 'Select Content Model'}
                styles={{ marginTop: '24px' }}
              />
            </Col>
          </Row>
        </div>
      );

    case 'checkbox':
      return (
        <div style={{ width: '100%' }}>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-name"
                id="standard-input-content-model-detail-text-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-id"
                id="standard-input-content-model-detail-text-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>
          </Row>
        </div>
      );

    case 'Select':
      return (
        <div style={{ width: '100%' }}>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-name"
                id="standard-input-content-model-detail-text-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-text-id"
                id="standard-input-content-model-detail-text-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>

            <Col
              span={24}
              style={{
                alignItems: 'flex-end',
                display: 'flex',
                marginTop: '24px'
              }}
            >
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-object-key"
                id="standard-input-content-model-detail-object-key"
                label="object key"
                onChange={onSelectElementChange}
                size="large"
                value={selectElement}
                width="true"
              />
              <CButton onClick={addSelectData} size="large" type="primary">
                Add
              </CButton>
              <CButton onClick={() => setShowObjectModal(true)} size="large" type="primary">
                View
              </CButton>
            </Col>

            {showObjectModal && (
              <Modal
                handleClose={() => setShowObjectModal(false)}
                isModalOpen={showObjectModal}
                styles={{
                  '& .MuiDialogContent-root': {
                    padding: '8px 24px 24px'
                  },
                  minHeight: '187px',
                  width: '460px'
                }}
                titleContent={<h2 className="modal-title">Keys</h2>}
              >
                {selectData.length
                  ? selectData.map((selectedDataElement, index) => {
                      return (
                        <div key={index} className={classes.keyWrapper}>
                          <button
                            className={classes.removeButton}
                            onClick={() => removeSelectElement(index)}
                            type="button"
                          >
                            x
                          </button>
                          <p>{selectedDataElement}</p>
                        </div>
                      );
                    })
                  : null}
              </Modal>
            )}
          </Row>
        </div>
      );

    default:
      return (
        <div>
          <Row align="middle">
            <Col span={24}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-name"
                id="standard-input-content-model-detail-name"
                label="Name"
                onChange={onNameChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor="standard-input-content-model-detail-id"
                id="standard-input-content-model-detail-id"
                label="Field ID"
                onChange={onApiIdChange}
                size="large"
                width="true"
              />
            </Col>

            <Col span={24} style={{ marginTop: '24px' }}>
              <CStandardInput
                allowClear
                disableUnderline
                formclasses={{
                  root: classes.root
                }}
                htmlFor="standard-input-content-model-detail-desc"
                id="standard-input-content-model-detail-desc"
                label="Description"
                multiline
                onChange={onRichTextChange}
                rows="3"
                size="large"
                width="true"
              />
            </Col>
          </Row>
        </div>
      );
  }
};

const NewFieldModal = ({ visible, onCancel, onOk }) => {
  const [currentProject, setCurrentProject] = useState({});
  const [projects, setProjects] = useState([]);
  const [remainingContentModelsToSelect, setRemainingContentModelsToSelect] = useState([]);
  const [typeChosen, setTypeChosen] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = useState(0);
  const [selectedFieldText, setSelectedFieldText] = useState('');
  const [name, setName] = useState('');
  const [apiId, setApiId] = useState('');
  const [id, setId] = useState('');
  const [hint, setHint] = useState('');
  const [characterLimit, setCharacterLimit] = useState(64);
  const [allowDisable, setAllowDisable] = useState(false);
  const [richText, setRichText] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [ratioWidth, setRatioWidth] = useState(16);
  const [ratioHeight, setRatioHeight] = useState(9);
  const [sizeLimit, setSizeLimit] = useState(350);
  const [objectData, setObjectData] = useState({});
  const [objectKey, setObjectKey] = useState('');
  const [selectElement, setSelectElement] = useState('');
  const [selectData, setSelectData] = useState([]);

  const customType = useSelector(({ customType }) => customType);

  useEffect(() => {
    const { customTypes, customTypeDraft } = customType;
    setCurrentProject(customTypeDraft);
    setProjects(customTypes);
  }, [customType]);

  useEffect(() => {
    if (!currentProject.template) return;
    const remainingContentModels = projects.filter((project) => {
      const { template } = currentProject;
      const isContentModelAlreadySelected = Object.prototype.hasOwnProperty.call(
        template,
        project.api_id
      );
      const isDisplayed = !isContentModelAlreadySelected;
      return isDisplayed;
    });
    setRemainingContentModelsToSelect([...remainingContentModels]);
  }, [projects, id]);

  function selectContentModel(selectedContentModel) {
    const { api_id: apiId, _id: id } = selectedContentModel;

    setApiId(apiId);
    setId(id);
  }

  const indexToType = (index) => {
    switch (index) {
      case 0:
        return { editText: 'Short Text Field', text: 'text' };
      case 1:
        return { editText: 'Rich Text Field', text: 'tinymce' };
      case 2:
        return { editText: 'Media Field', text: 'file' };
      case 3:
        return { editText: 'Files Field', text: 'files' };
      case 4:
        return { editText: 'Enter List', text: 'list' };
      case 5:
        return { editText: 'Enter Date', text: 'date' };
      case 6:
        return { editText: 'Create Object', text: 'complex list' };
      case 7:
        return { editText: 'Connect Content Model & Content', text: 'Connect To Content' };
      case 8:
        return { editText: 'Create Page Content', text: 'Content Model' };
      case 9:
        return { editText: 'Add Checkbox to Content Model', text: 'checkbox' };
      case 10:
        return { editText: 'Select Field', text: 'Select' };
      default:
        return 'text';
    }
  };

  const onFieldTypeClick = (index) => {
    setTypeChosen(true);
    setSelectedFieldType(indexToType(index).text);
    setSelectedFieldText(indexToType(index).editText);
  };

  const onModalCancel = () => {
    onCancel();
  };

  useEffect(() => {
    if (visible === false) return;
    setTypeChosen(false);
    setObjectKey('');
    setObjectData({});
    setSelectData([]);
    setId('');
  }, [visible]);

  const getPropsForFieldType = () => {
    switch (selectedFieldType) {
      case 'text':
        return { characterLimit, hint };
      case 'tinymce':
        return { richText };
      case 'file':
        return { ratioHeight, ratioWidth, sizeLimit };
      case 'date':
        return { selectedDate };
      case 'complex list':
        return { ...objectData };
      case 'Connect To Content':
        return { id };
      case 'Content Model':
        return { id };
      case 'Select':
        return { selectData: [...selectData] };
      default:
        break;
    }
  };

  const onConfirm = () => {
    const props = getPropsForFieldType();
    setTypeChosen(false);
    setName('');
    setApiId('');
    setObjectKey('');
    setObjectData({});
    setSelectData([]);
    setId('');
    onOk({ apiId, name, props, type: selectedFieldType });
  };

  const onBack = () => {
    setTypeChosen(false);
  };

  const getFooter = () => {
    if (!typeChosen) {
      return [];
    }

    return [
      <CButton key={1} onClick={onModalCancel} size="large" type="secondary">
        Cancel
      </CButton>,
      <CButton key={2} disabled={allowDisable} onClick={onConfirm} size="large" type="primary">
        Add
      </CButton>
    ];
  };

  return (
    <div>
      <Modal
        footerActions={typeChosen ? getFooter() : null}
        handleClose={onModalCancel}
        isModalOpen={visible}
        styles={{
          '& .MuiDialogContent-root': {
            padding: typeChosen ? '24px 24px 16px' : '24px 24px 40px'
          },
          width: '460px'
        }}
        titleContent={
          typeChosen ? (
            <div>
              <div className="modal-header-go-back" onClick={onBack}>
                <img alt="arrow back" src={ArrowBack} />
                <span>Back</span>
              </div>
              <span className="modal-title">{selectedFieldText}</span>
            </div>
          ) : (
            <span className="modal-title">Add field</span>
          )
        }
      >
        {!typeChosen && <ChooseFieldType onClick={onFieldTypeClick} />}
        {typeChosen && (
          <FieldDetails
            addObjectKey={() => {
              const stringWithoutSpaces = objectKey.trim(/\s/g, '');
              if (stringWithoutSpaces.length !== 0) {
                setObjectData((oldData) => {
                  return { ...oldData, [objectKey]: '' };
                });
              }
              setObjectKey('');
            }}
            addSelectData={() => {
              const stringWithoutSpaces = selectElement.trim();
              if (stringWithoutSpaces.length !== 0) {
                setSelectData((oldData) => {
                  return [...oldData, stringWithoutSpaces];
                });
              }
              setSelectElement('');
            }}
            apiId={apiId}
            name={name}
            objectData={objectData}
            objectKey={objectKey}
            onApiIdChange={(event) => setApiId(event.target.value)}
            onCharacterLimitChange={(event) => {
              setCharacterLimit(event.target.value);
              setAllowDisable(event.target.value <= 0);
            }}
            onHeightChange={(event) => {
              setRatioHeight(event.target.value);
              setAllowDisable(event.target.value <= 0);
            }}
            onHintChange={(event) => setHint(event.target.value)}
            onNameChange={(event) => setName(event.target.value)}
            onObjectKeyChange={(event) => setObjectKey(event.target.value)}
            onRichTextChange={(event) => setRichText(event.target.value)}
            onSelectElementChange={(event) => setSelectElement(event.target.value)}
            onSizeLimitChange={(event) => {
              setSizeLimit(event.target.value);
              setAllowDisable(event.target.value <= 0);
            }}
            onWidthChange={(event) => {
              setRatioWidth(event.target.value);
              setAllowDisable(event.target.value <= 0);
            }}
            remainingContentModelsToSelect={remainingContentModelsToSelect}
            removeKey={(key) => {
              const newObj = { ...objectData };
              delete newObj[key];
              setObjectData(newObj);
            }}
            removeSelectElement={(index) => {
              const selectDataCopy = [...selectData];
              selectDataCopy.splice(index, 1);
              setSelectData(selectDataCopy);
            }}
            selectContentModel={selectContentModel}
            selectData={selectData}
            selectedContentModelData={projects.filter((project) => project.api_id === apiId)[0]}
            selectedDate={selectedDate}
            selectedFieldType={selectedFieldType}
            selectElement={selectElement}
            setSelectedDate={setSelectedDate}
          />
        )}
      </Modal>
    </div>
  );
};

export default NewFieldModal;
